import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { USER_AUTHINFOS } from "manager/http-constants";
import { SESSION_KEY } from "src/app/shared/constant/session-constants";
import { map } from "rxjs/operators";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { CommonService } from "./common.service";
import {
  MessageData,
  ToastMessageData,
} from "../html-parts/message-common/message-data";
import { TOAST } from "../constant/primeng-constants";

const credentialsKey = 'access_token';

@Injectable({
  providedIn: "root",
})

/**
 * ログイン処理
 */
export class LoginService {
  private _currentUser: any;
  private _credentials: any;
  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageData: MessageData
  ) {
    this.getCredentialsFromLocalStorage();
    const self = this
    window.addEventListener('storage', function(e) {
      const savedCredentials = localStorage.getItem(credentialsKey);
      if (!savedCredentials) {
        self.logout();
      }
    });
  }

  /**
   * ログアウト処理
   * @param messageCode メッセージコード
   */
  public logout(messageCode?: string): void {
    sessionStorage.clear();
    localStorage.clear();

    this.setCurrentUser(null);

    // メッセージコードが存在するか否か
    if (!messageCode) {
      // メッセージコードが存在しない場合

      // メッセージコード(ログアウトしました)を標準セット
      messageCode = MESSAGE_CODE.N90000;
    }

    // セッションにログアウト画面用のメッセージコードを格納
    window.sessionStorage.setItem(SESSION_KEY.loginOutMessageCode, messageCode)
    
    const urlLogout = window.location.origin + '/login?redirect_uri={0}'
    window.location.href = urlLogout.replace('{0}', window.location.origin + '/pages/platform/b301')
  }

  getCredentialsFromLocalStorage() {
    const savedCredentials = localStorage.getItem(credentialsKey);
    if (savedCredentials) {
      this._credentials = savedCredentials;
    }
  }

  /**
   * ログインユーザ情報取得
   * @returns JSONデータ
   */
  public getLoginUser(): Observable<any> {
    // ログインユーザ情報を返却する
    return this.http
      .get(this.commonService.url(USER_AUTHINFOS), { observe: "response" })
      .pipe(map((res: HttpResponse<any>) => res));
  }

  /**
   * ログインメッセージ
   * @param loginUserName ログインユーザ名
   */
  public loginMessage(loginUserName?: string): void {
    // ログインメッセージを出力
    this.messageData.toastMessage(
      new ToastMessageData({
        severity: TOAST.INFO,
        summary: this.commonService.msg(MESSAGE_CODE.N80000),
        detail: this.commonService.msg(MESSAGE_CODE.N80001, loginUserName),
        position: TOAST.TOP_RIGHT,
        life: 5000,
      })
    );
    sessionStorage.setItem("loginState", "1");
  }

  /**
   * ログアウトメッセージ
   */
  public logoutMessage(): void {
    // ログアウトメッセージを出力
    this.messageData.toastMessage(
      new ToastMessageData({
        severity: TOAST.INFO,
        summary: this.commonService.msg(MESSAGE_CODE.N80002),
        detail: this.commonService.msg(MESSAGE_CODE.N80003),
        position: TOAST.TOP_RIGHT,
        life: 5000,
      })
    );
  }

  public getAuth0LoginState(): any {
    return !!this.credentials;
  }

  /**
   * Gets the user credentials.
   * @return The user credentials or null if the user is not authenticated.
   */
  get credentials(): any {
    return this._credentials;
  }

  public getAuth0LoginToken(): Observable<any> {
    return this.credentials;
  }

  /**
   * Sets the user credentials.
   * Otherwise, the credentials are only persisted for the current session.
   * @param credentials The user credentials.
   */
  setCredentials(credentials?: string) {
    this._credentials = credentials || null;

    if (credentials) {
      localStorage.setItem(credentialsKey, credentials);
    } else {
      localStorage.removeItem(credentialsKey);
    }
  }
  
  /**
   * Authenticates the user.
   * @param context The login parameters.
   * @return The user credentials.
   */
  login(code: any, redirect_uri: any): Observable<any> {
    console.log(1);
    // Replace by proper authentication call
    const AUTH_TOKEN = 'https://ap-northeast-1y0hliselz.auth.ap-northeast-1.amazoncognito.com/oauth2/token'
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    const dataBody = {
      'grant_type': 'authorization_code',
      'client_id': '7q9bkcbgns3tujmq3nulhs2bu2',
      'code': code,
      'redirect_uri': redirect_uri,
      'client_secret': 'is5jkiqcrq99lu3ra6v81vph414bk3onk37ggh8l90do9391rhg'
    }
    const formBody = [];
    for (const property in dataBody) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(dataBody[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    const body = formBody.join("&");
    let options = { headers: headers };
    return this.http.post(
      AUTH_TOKEN,
      body,
      options
    ).pipe(
      map((data: any) => {
        // login successful if there's a jwt token in the response
        if (data && data.id_token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          this.setCredentials(data.id_token);
        }
        return data.id_token;
      })
    );
  }

  public getCurrentUser() : any {
    return this._currentUser;
  }

  public setCurrentUser(user: any) {
    this._currentUser = user;
  }

  /**
   * check if loginUser is loaded
   * used on page that requires a login user on initial and header or interceptor might not have finish loading loginUser after page reload
   * will set current login user to service if login state is true
   * @returns true: if there is a current user loaded to service 
   *          true: loaded user but login state is true (this will set current user)
   *          false: no login user and/or login state is false
   */
  public checkLoginUser() {
    return new Promise<any>((resolve) => {
      if (!this._currentUser && this.getAuth0LoginState()) {
        this.getLoginUser().subscribe((response) => {
          if (this.commonService.checkNoneResponse(response)) {
            resolve(false);
          } else {
            this.setCurrentUser(response.body);
            resolve(true);
          }
        });
      } else {
        resolve(this.getAuth0LoginState());
      }
    });
  }
}
